import { type RefObject, useEffect } from 'react'

export function useFocusOut(ref: RefObject<HTMLElement | null>, handleOnFocusOut: (event: FocusEvent) => void) {
  useEffect(() => {
    function listener(event: FocusEvent) {
      const target = event?.relatedTarget

      // If the new focus target is still inside the container, do nothing
      if (target instanceof Node && ref.current?.contains(target)) {
        return
      }

      handleOnFocusOut(event)
    }
    document.addEventListener('focusout', listener)

    return () => {
      document.removeEventListener('focusout', listener)
    }
  }, [ref, handleOnFocusOut])
}
